<template>
  <div
    class="context-menu"
    v-if="isVisible"
    :style="{
      left: `${left}px`,
      top: `${top}px`,
    }"
    @contextmenu.capture.prevent
  >
    <el-menu class="el-menu-vertical">
      <div v-for="(item, index) in items" :key="index">
        <el-divider v-if="item.divided"></el-divider>
        <el-menu-item
          :index="index.toString()"
          :disabled="item.disabled"
          @click="$emit('click', item.click(row))"
        >
          <i :class="item.icon" v-if="item.icon"></i>
          <span>{{ item.label }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    offset: {
      type: Object,
      default: {
        right: 0,
        bottom: 0,
      },
    },
    row: Object,
    items: {
      type: Array,
      default: [
        {
          label: "",
          icon: "",
          disabled: false,
          divided: false,
          click: (row) => {},
        },
      ],
    },
  },
  data() {
    return {
      top: 0,
      left: 0,
    };
  },
  computed: {
    ...mapState({
      isVisible: (state) => state.isContextMenuVisible,
    }),
  },
  watch: {
    isVisible(val) {
      if (val) {
        event.preventDefault();
        this.top = event.pageY;
        this.left = event.pageX;
        this.openMenu();
      }
    },
  },
  methods: {
    ...mapMutations({
      setContextMenuVisible: "setContextMenuVisible",
    }),
    async openMenu() {
      await this.$nextTick();
      const body = document.body,
        html = document.documentElement,
        menu = this.$el,
        height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        ),
        width = Math.max(
          body.scrollWidth,
          body.offsetWidth,
          html.clientWidth,
          html.scrollWidth,
          html.offsetWidth
        ),
        menuHeight = menu.clientHeight,
        menuWidth = menu.clientWidth,
        bottom = height - this.top,
        right = width - this.left;

      if (bottom < this.offset.bottom) this.top -= menuHeight;
      if (right < this.offset.right) this.left -= menuWidth;
      document.addEventListener("click", this.closeMenu);
      document.addEventListener("mousedown", this.closeMenu);
    },
    closeMenu() {
      if (
        (event.type === "mousedown" && event.button != 0) ||
        event.type === "click"
      ) {
        this.setContextMenuVisible(false);
        document.removeEventListener("click", this.closeMenu);
        document.removeEventListener("mousedown", this.closeMenu);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.context-menu
  z-index: 1000
  display: block
  position: absolute
.el-menu-vertical
  border: 1px solid #e6e6e6
  border-radius: 5px
</style>
